import { render, staticRenderFns } from "./MaskedIconLink.vue?vue&type=template&id=9bf88484&scoped=true"
import script from "./MaskedIconLink.vue?vue&type=script&lang=js"
export * from "./MaskedIconLink.vue?vue&type=script&lang=js"
import style0 from "./MaskedIconLink.vue?vue&type=style&index=0&id=9bf88484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf88484",
  null
  
)

export default component.exports